import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { apiClient, storePath } from '@/lib/api-client';
import type { StoreScreenshot } from '@/types/store';

import { storeKeys } from './store-keys';

/** GET /admin/store-metadata/screenshots — every screenshot slot (all platforms/locales). */
export function useStoreScreenshots(): UseQueryResult<StoreScreenshot[], Error> {
  return useQuery({
    queryKey: storeKeys.screenshots(),
    queryFn: ({ signal }) => apiClient.get<StoreScreenshot[]>(storePath('/screenshots'), signal),
  });
}
